import { render, staticRenderFns } from "./ScheduleType.vue?vue&type=template&id=605810f0&scoped=true&"
import script from "./ScheduleType.vue?vue&type=script&lang=js&"
export * from "./ScheduleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605810f0",
  null
  
)

export default component.exports